import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import HeroSection1 from "../components/EduComponents/HeroSection1";
import Passion from "../components/EduComponents/Passion";
import Introduction from "../components/EduComponents/Introduction";
import FeaturesSection from "../components/EduComponents/FeaturesSection";
import FaqSection from "../components/EduComponents/FaqSection";
import ContactUsForm from "../components/EduComponents/ContactUsForm";
import DemoSection from "../components/EduComponents/DemoSection";
// import Testimonials from "../components/HomeComponents/Testimonials";
import Testimonials1 from "../components/EduComponents/Testimonials1";
import Pricing from "../components/EduComponents/Pricing";
import SponsoredTrain from "../components/EduComponents/SponsoredTrain";
function Academies() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash === "#contact-us-form") {
      const scrollToContactForm = () => {
        const element = document.getElementById("contact-us-form");
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      };

      scrollToContactForm();
      requestAnimationFrame(scrollToContactForm);
      setTimeout(scrollToContactForm, 120);
    }
  }, [location.hash]);

  return (
    <div>
      <Helmet>
        <title>List Your Academy Online & Get Students | Strawket</title>
        <meta
          name="description"
          content="Grow your institute with Strawket. List your academy, manage inquiries, connect with students, and increase visibility across cities with zero hassle."
        />
        <meta
          name="keywords"
          content="Strawket for academies, academy learning platform, smart education, digital transformation for institutes, student engagement tools, online academy solutions"
        />
        <link rel="canonical" href="https://strawket.com/academies" />

        {/* Open Graph (for social sharing) */}
        <meta
          property="og:title"
          content="List Your Academy & Get More Students | Strawket"
        />
        <meta
          property="og:description"
          content="Register your learning academy on Strawket to boost visibility and attract more students. Manage profiles, courses, and inquiries all in one place."
        />
        <meta property="og:url" content="https://strawket.com/academies" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://strawket.com/static/media/logo.18f8cc4a64e05c1ba825.png"
        />
        <meta property="og:site_name" content="Strawket" />

        {/* Twitter Card */}
        <meta
          name="twitter:title"
          content="Strawket for Academies | Elevate Your Institute’s Learning Experience"
        />
        <meta
          name="twitter:description"
          content="Discover how Strawket helps academies digitize learning, host demos, and track student progress — all in one place."
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:image"
          content="https://www.strawket.com/assets/images/strawket-academies-preview.png"
        />
      </Helmet>

      <HeroSection1 />
      <Passion />
      <SponsoredTrain />
      {/* <Introduction /> */}
      <FeaturesSection />
      <Pricing />
      <Testimonials1 />
      <FaqSection />
      <ContactUsForm />
      {/* <DemoSection /> */}
    </div>
  );
}
export default Academies;
